import React, { SVGProps } from 'react';

interface LogoProps extends SVGProps<SVGSVGElement> {
	className?: string;
	pro?: boolean;
}

const BundleLogo: React.FC<LogoProps> = ({ className, pro, ...props }) =>
	pro ? (
		<svg
			viewBox="-18 -24 377 153"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-labelledby="title"
			role="img"
			{...props}
		>
			<path
				d="M37.0678 26.5563C30.2748 26.5563 23.9182 28.4009 18.4768 31.6099V0.557129H0.695312V62.5165C0.695312 82.383 16.9774 98.4837 37.0678 98.4837C57.1582 98.4837 73.4402 82.383 73.4402 62.5165C73.4402 42.65 57.1582 26.5493 37.0678 26.5493V26.5563ZM37.0678 80.9073C26.7973 80.9073 18.4768 72.6725 18.4768 62.5234C18.4768 52.3744 26.8044 44.1396 37.0678 44.1396C47.3312 44.1396 55.6588 52.3744 55.6588 62.5234C55.6588 72.6725 47.3312 80.9073 37.0678 80.9073Z"
				fill="#2C4454"
			/>
			<path
				d="M218.963 1V32.0528C213.522 28.8438 207.165 26.9991 200.372 26.9991C180.282 26.9991 164 43.0998 164 62.9663C164 82.8329 180.282 98.9335 200.372 98.9335C220.463 98.9335 236.745 82.8329 236.745 62.9663V1.00696H218.963V1ZM200.372 81.3432C190.102 81.3432 181.781 73.1084 181.781 62.9594C181.781 52.8103 190.109 44.5755 200.372 44.5755C210.636 44.5755 218.963 52.8103 218.963 62.9594C218.963 73.1084 210.636 81.3432 200.372 81.3432Z"
				fill="#2C4454"
			/>
			<path d="M241.336 96.3815H259.117V0.557114H241.336V96.3815Z" fill="#2C4454" />
			<path
				d="M159.974 56.7459C159.974 40.0744 146.303 26.5563 129.444 26.5563C112.585 26.5563 98.9141 40.0744 98.9141 56.7459H98.9352V68.3289C98.9352 73.1807 102.912 77.1206 107.826 77.1206C112.739 77.1206 116.717 73.1876 116.717 68.3289V56.7459H116.696C116.696 49.7849 122.404 44.1396 129.444 44.1396C136.483 44.1396 142.192 49.7849 142.192 56.7459V96.3815H159.974V56.7459Z"
				fill="#2C4454"
			/>
			<path
				d="M129.466 47.9263C124.559 47.9263 120.575 51.8593 120.575 56.718V68.301C120.575 75.262 114.866 80.9073 107.827 80.9073C100.787 80.9073 95.0783 75.262 95.0783 68.301V28.6654H77.2969V68.301C77.2969 84.9725 90.9674 98.4906 107.827 98.4906C124.686 98.4906 138.356 84.9725 138.356 68.301V56.718C138.356 51.8662 134.379 47.9263 129.466 47.9263Z"
				fill="#2C4454"
			/>
			<path
				d="M317.876 62.1337C317.988 68.0157 315.257 73.8489 310.034 77.5034C303.501 82.0837 295.005 81.8958 288.761 77.6635L332.208 47.2303C331.307 45.3299 330.23 43.4853 328.963 41.7103C317.355 25.4982 294.653 21.6697 278.258 33.1483C261.863 44.6269 257.992 67.076 269.6 83.288C281.208 99.5 303.91 103.329 320.304 91.8499C330.413 84.7707 335.749 73.5218 335.643 62.1406H317.862L317.876 62.1337ZM288.543 47.5018C294.786 43.1303 302.818 43.1024 308.957 46.7987L281.095 66.3102C279.61 59.3493 282.299 51.8663 288.543 47.4948V47.5018Z"
				fill="#2C4454"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M317.088 3C312.163 3 308.172 6.94958 308.172 11.8229C308.172 16.6963 312.163 20.6459 317.088 20.6459C322.012 20.6459 326.004 16.6963 326.004 11.8229C326.004 6.94958 322.012 3 317.088 3ZM312.531 11.8212C312.531 14.3108 314.57 16.3309 317.088 16.3309C319.604 16.3309 321.645 14.3108 321.645 11.8212C321.645 9.33161 319.604 7.31158 317.088 7.31158C314.572 7.31158 312.531 9.33161 312.531 11.8212Z"
				fill="#2C4454"
			/>
			<path
				d="M282.008 20.6281C280.326 20.6281 278.751 20.176 277.404 19.3895V27H273V11.8149C273 6.94598 277.032 3 282.008 3C286.984 3 291.016 6.94598 291.016 11.8149C291.016 16.6838 286.984 20.6298 282.008 20.6298V20.6281ZM282.008 7.30765C279.465 7.30765 277.404 9.32585 277.404 11.8132C277.404 14.3005 279.466 16.3187 282.008 16.3187C284.55 16.3187 286.612 14.3005 286.612 11.8132C286.612 9.32585 284.55 7.30765 282.008 7.30765Z"
				fill="#2C4454"
			/>
			<path
				d="M292.073 10.3989C292.073 6.31305 295.459 3 299.634 3C303.81 3 307.195 6.31305 307.195 10.3989H307.19V13.2377H304.952C304.952 13.2377 302.786 13.2934 302.786 13.2377V10.3989H302.791C302.791 8.69292 301.378 7.30935 299.634 7.30935C297.891 7.30935 296.477 8.69292 296.477 10.3989V20.1129H292.073V10.3989Z"
				fill="#2C4454"
			/>
		</svg>
	) : (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 2098 853"
			className={className}
			aria-labelledby="title"
			role="img"
			{...props}
		>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M1246.090820,279.935791 
      C1278.063599,281.527008 1307.540405,291.370544 1335.827515,307.489380 
      C1335.827515,248.920868 1335.827515,190.920776 1335.827515,132.558014 
      C1369.265747,132.558014 1402.172974,132.558014 1435.920410,132.558014 
      C1435.920410,134.107697 1435.920410,135.844315 1435.920410,137.580933 
      C1435.920410,251.885345 1436.014282,366.189911 1435.839844,480.494049 
      C1435.805664,502.870972 1433.177002,525.013428 1425.843750,546.352905 
      C1416.287476,574.161133 1401.899902,599.041199 1381.845215,620.725586 
      C1352.908325,652.013855 1317.523926,672.045166 1276.289307,681.745605 
      C1265.878296,684.194885 1255.019165,685.105774 1244.306030,685.799866 
      C1233.835083,686.478271 1223.189209,686.900818 1212.795654,685.791382 
      C1194.140381,683.800171 1175.924561,679.378052 1158.369873,672.497192 
      C1136.761230,664.027405 1117.241699,652.228210 1099.615234,637.082336 
      C1079.420166,619.729309 1063.299683,599.209412 1051.150146,575.645203 
      C1040.818481,555.606995 1033.511719,534.389404 1031.199463,511.890594 
      C1029.662109,496.931580 1028.324341,481.722412 1029.323608,466.787567 
      C1030.736694,445.667786 1035.932617,425.110901 1044.035645,405.363983 
      C1052.372681,385.047089 1063.556152,366.381256 1077.913208,349.966278 
      C1092.241089,333.584656 1108.730469,319.411469 1127.618652,308.176086 
      C1143.815796,298.541412 1160.869019,290.873535 1179.099854,286.442047 
      C1191.848511,283.343262 1205.042358,282.076294 1218.945801,280.033630 
      C1228.599731,280.029327 1237.345337,279.982574 1246.090820,279.935791 
    M1328.056885,442.658173 
      C1322.205811,429.384216 1313.999512,417.903961 1303.514893,407.752808 
      C1294.081665,398.619507 1283.363770,391.802155 1271.419800,386.860260 
      C1253.046631,379.258362 1234.069092,377.490967 1214.355347,380.872284 
      C1194.542480,384.270630 1177.157471,392.496490 1162.621094,406.021179 
      C1139.682739,427.363098 1128.196289,453.845825 1128.748657,485.497894 
      C1129.046265,502.553619 1133.546631,518.333069 1141.593506,533.106995 
      C1160.761230,568.298157 1203.839966,592.667908 1247.091064,585.388916 
      C1281.235474,579.642517 1307.075684,562.107788 1323.583130,531.925537 
      C1339.155396,503.453766 1340.061401,473.616699 1328.056885,442.658173 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M334.087524,279.932281 
      C357.931488,281.270355 380.774811,286.788849 402.585236,296.495026 
      C427.548859,307.604431 449.568695,322.984711 468.222717,342.946838 
      C488.531525,364.679688 503.752869,389.421783 513.213806,417.870575 
      C519.055298,435.435730 521.909302,453.232483 523.091309,471.583252 
      C526.494751,524.422546 510.904816,571.054382 477.570221,611.786011 
      C446.094574,650.246216 405.682190,674.017456 356.737976,682.888977 
      C347.388733,684.583618 337.827667,685.296692 328.329010,685.946777 
      C292.429626,688.403687 258.829010,679.608093 226.985703,663.812073 
      C212.587372,656.669617 199.463089,647.321899 187.237442,636.709106 
      C172.909195,624.271118 160.433151,610.260132 150.206192,594.364868 
      C133.742157,568.775757 122.556839,541.072205 119.099457,510.646545 
      C117.907349,500.155823 117.154579,489.552826 117.141861,479.000000 
      C117.005104,365.501221 117.056664,252.002243 117.056664,138.503311 
      C117.056664,136.553955 117.056664,134.604614 117.056664,132.428589 
      C150.491852,132.428589 183.404724,132.428589 216.669449,132.428589 
      C216.669449,190.592560 216.669449,248.533020 216.669449,307.483917 
      C244.937851,291.781708 274.185211,281.562408 306.928558,280.038147 
      C316.596313,280.033447 325.341919,279.982849 334.087524,279.932281 
    M420.763824,509.917358 
      C420.859619,508.595886 420.707672,507.197693 421.089569,505.964844 
      C424.747314,494.156555 424.701813,482.163177 423.270416,470.036499 
      C419.990295,442.247986 407.005432,419.597931 385.582764,402.213806 
      C364.050262,384.740540 339.031555,377.100647 311.112396,379.685089 
      C267.239716,383.746307 231.085678,413.933990 220.235626,456.233307 
      C213.748672,481.522919 215.597092,506.396912 227.990799,529.506836 
      C247.093597,565.126892 276.850555,584.820923 317.813477,586.270020 
      C341.337738,587.102295 362.345032,580.263367 381.432312,566.369263 
      C400.935120,552.172668 413.553345,533.526978 420.763824,509.917358 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M1989.063110,496.091339 
      C1987.459961,517.929810 1982.707397,538.902100 1974.477661,559.352722 
      C1963.066406,587.708862 1946.148193,611.978699 1923.799561,632.497681 
      C1896.328613,657.719727 1864.277588,674.221985 1827.692383,682.029053 
      C1809.341675,685.944885 1790.790039,687.191650 1772.288452,685.577698 
      C1757.911865,684.323486 1743.609131,681.241455 1729.516479,677.936096 
      C1706.476807,672.532227 1685.876221,661.386841 1666.793701,647.786621 
      C1651.822632,637.116516 1638.723999,624.230835 1627.202271,609.722839 
      C1611.301270,589.700500 1599.572144,567.593262 1591.885986,543.261169 
      C1586.127319,525.030945 1583.569946,506.379303 1582.853516,487.264343 
      C1581.833008,460.037201 1586.803711,433.828430 1596.414795,408.741272 
      C1603.843628,389.349579 1614.363037,371.349274 1627.564697,354.955414 
      C1641.544189,337.595978 1657.932983,323.150726 1676.566162,311.174133 
      C1699.784912,296.250336 1725.079834,286.617554 1752.326294,282.007568 
      C1781.052368,277.147125 1809.396729,278.517822 1837.597290,285.872131 
      C1865.831055,293.235046 1891.112427,306.104919 1913.879761,324.316620 
      C1937.178711,342.953827 1955.029419,365.818634 1968.554565,392.264648 
      C1969.972168,395.036774 1970.190796,396.786652 1967.315796,398.815430 
      C1917.421997,434.025391 1867.588867,469.321289 1817.747314,504.605316 
      C1788.098389,525.594604 1758.457642,546.595337 1728.820801,567.601624 
      C1728.561523,567.785339 1728.406250,568.115845 1727.825684,568.861938 
      C1761.353027,589.208801 1796.182129,593.227783 1831.553955,575.727417 
      C1869.850342,556.780090 1888.469727,524.432495 1890.560303,481.520020 
      C1923.626099,481.038452 1956.172485,481.038452 1989.063110,481.038452 
      C1989.063110,486.504791 1989.063110,491.298065 1989.063110,496.091339 
    M1715.551514,482.075684 
      C1716.132080,481.487701 1716.636963,480.790955 1717.304077,480.327759 
      C1729.191772,472.073730 1741.158447,463.932220 1752.988281,455.596405 
      C1770.241211,443.439240 1787.399902,431.148224 1804.596680,418.911285 
      C1816.180298,410.668488 1827.760376,402.420624 1839.514893,394.051941 
      C1801.813599,371.190857 1753.056152,374.273254 1718.310303,404.189575 
      C1684.984009,432.883759 1677.703735,475.936798 1685.277222,503.198853 
      C1695.247681,496.286438 1705.133301,489.432983 1715.551514,482.075684 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M908.169922,673.754700 
      C908.124817,671.758301 908.040527,669.761963 908.040344,667.765564 
      C908.033630,595.800110 908.115967,523.834473 907.966553,451.869385 
      C907.936340,437.338501 904.760864,423.436676 896.247375,411.266937 
      C881.419617,390.070984 861.097168,378.476685 835.138428,379.149536 
      C802.666260,379.991180 776.004883,400.941772 768.051086,432.924072 
      C766.599304,438.761658 766.077026,444.952393 766.009033,450.990082 
      C765.770752,472.143890 766.101501,493.304047 765.872742,514.458069 
      C765.596985,539.955322 749.976257,559.009644 726.194275,564.558960 
      C699.799255,570.718079 671.258606,551.974670 667.053345,524.526245 
      C666.578064,521.424377 666.159790,518.275818 666.146484,515.147034 
      C666.039062,489.827576 665.089722,464.459839 666.368835,439.206665 
      C667.086182,425.044403 670.466248,410.751038 674.534485,397.078461 
      C683.722168,366.200256 701.897278,340.689301 726.074707,319.822266 
      C750.126526,299.063568 778.436951,286.609833 809.794373,281.298676 
      C814.159729,280.559357 818.625732,280.414978 823.944946,280.043213 
      C832.924377,280.037170 841.004089,279.983154 849.083801,279.929138 
      C883.810974,282.254272 914.758240,294.335724 942.180786,315.729126 
      C963.990173,332.743469 980.837036,353.762512 991.993347,378.969086 
      C996.752075,389.720978 999.842041,401.287903 1002.873840,412.701355 
      C1004.973877,420.607269 1005.677490,428.884094 1006.951172,437.914795 
      C1006.897217,517.025452 1006.897217,595.216431 1006.897217,673.754700 
      C973.687683,673.754700 940.928772,673.754700 908.169922,673.754700 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M644.812744,292.249756 
      C644.856201,294.247101 644.937439,296.244476 644.937622,298.241821 
      C644.944336,370.734894 644.998108,443.227997 644.903381,515.720947 
      C644.881287,532.615662 650.473938,547.475769 660.927307,560.365784 
      C680.023254,583.912903 711.240845,592.585693 739.854126,582.221436 
      C762.826721,573.900330 777.767334,557.535095 784.509460,534.087219 
      C786.213806,528.159729 786.897583,521.764648 786.966858,515.572205 
      C787.227905,492.245209 786.793701,468.909454 787.143860,445.584839 
      C787.286804,436.056915 791.224243,427.309418 797.020874,419.909698 
      C808.018372,405.870880 822.774963,399.014587 840.668030,400.223053 
      C861.525879,401.631714 881.632080,417.439667 884.953857,438.516663 
      C885.976196,445.003601 886.725037,451.599854 886.808044,458.156097 
      C887.050598,477.317841 887.223633,496.491669 886.815002,515.647766 
      C886.237915,542.704651 881.079834,568.745239 868.323242,592.982727 
      C851.922913,624.143311 828.642761,648.535889 797.724426,665.494812 
      C774.556885,678.202393 749.761902,684.661133 723.327942,686.174133 
      C699.958740,687.511719 677.485840,683.510071 655.923523,675.663635 
      C637.173096,668.840576 620.037170,658.486633 604.745239,645.219177 
      C585.997192,628.953064 571.309509,609.750610 560.936096,587.295532 
      C552.549316,569.140991 547.148865,550.121033 546.072449,529.116394 
      C546.144165,449.664795 546.144165,371.132538 546.144165,291.992554 
      C548.365234,291.992554 550.144897,291.992554 551.924561,291.992554 
      C566.243164,291.992554 580.561890,291.959412 594.880371,292.001221 
      C611.524536,292.049835 628.168640,292.164032 644.812744,292.249756 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M1462.166992,673.651733 
      C1462.146240,645.330750 1462.108765,617.009827 1462.107666,588.688843 
      C1462.101807,438.751404 1462.104980,288.813995 1462.104980,138.876572 
      C1462.104980,136.891068 1462.104980,134.905563 1462.104980,132.557251 
      C1495.386719,132.557251 1528.412476,132.557251 1561.909790,132.557251 
      C1561.909790,312.750519 1561.909790,492.795258 1561.418701,673.367188 
      C1529.992798,673.931213 1499.057861,673.974609 1468.123047,673.989319 
      C1466.137695,673.990234 1464.152344,673.769409 1462.166992,673.651733 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M644.736633,291.808044 
      C628.168640,292.164032 611.524536,292.049835 594.880371,292.001221 
      C580.561890,291.959412 566.243164,291.992554 551.924561,291.992554 
      C550.144897,291.992554 548.365234,291.992554 546.144165,291.992554 
      C546.144165,371.132538 546.144165,449.664795 546.073303,528.674561 
      C545.682556,527.428711 545.084290,525.705566 545.082947,523.981934 
      C545.022095,447.482056 545.013367,370.982147 545.005981,294.482208 
      C545.005859,293.509796 545.103516,292.537384 545.170593,291.284149 
      C546.320007,291.177002 547.268494,291.011719 548.217102,291.011292 
      C579.383728,290.997437 610.550415,290.996033 641.717041,291.014374 
      C642.698242,291.014954 643.679382,291.243866 644.736633,291.808044 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M908.264160,674.186890 
      C940.928772,673.754700 973.687683,673.754700 1006.897217,673.754700 
      C1006.897217,595.216431 1006.897217,517.025452 1006.971313,438.362762 
      C1007.358154,439.270844 1007.943481,440.650421 1007.944458,442.030396 
      C1007.998169,518.516541 1008.003418,595.002747 1008.005493,671.488892 
      C1008.005554,672.457581 1007.900635,673.426270 1007.828064,674.681519 
      C1006.687561,674.788513 1005.738647,674.954895 1004.789551,674.955322 
      C973.628540,674.969299 942.467468,674.970520 911.306458,674.953064 
      C910.323730,674.952515 909.341125,674.735229 908.264160,674.186890 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M1989.409302,495.831055 
      C1989.063110,491.298065 1989.063110,486.504791 1989.063110,481.038452 
      C1956.172485,481.038452 1923.626099,481.038452 1890.623413,481.081238 
      C1891.109497,480.748291 1892.051147,480.045654 1892.994019,480.044159 
      C1924.636353,479.994598 1956.278809,480.010803 1987.921265,480.029480 
      C1988.398560,480.029755 1988.875854,480.181213 1989.755493,480.330353 
      C1989.755493,485.399994 1989.755493,490.485382 1989.409302,495.831055 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M1462.218750,674.101440 
      C1464.152344,673.769409 1466.137695,673.990234 1468.123047,673.989319 
      C1499.057861,673.974609 1529.992798,673.931213 1561.380493,673.818176 
      C1560.766357,674.161072 1559.700195,674.944397 1558.632324,674.946594 
      C1527.316772,675.010986 1496.000977,675.000854 1464.685303,674.977905 
      C1463.880249,674.977295 1463.075439,674.699646 1462.218750,674.101440 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M1245.830322,279.589172 
      C1237.345337,279.982574 1228.599731,280.029327 1219.384521,280.003479 
      C1223.053833,279.615204 1227.188843,279.126373 1231.332886,279.029572 
      C1236.074219,278.918732 1240.823853,279.156342 1245.830322,279.589172 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M333.827576,279.585541 
      C325.341919,279.982849 316.596313,280.033447 307.380951,280.009399 
      C311.050476,279.618195 315.185699,279.128662 319.330139,279.030609 
      C324.071686,278.918427 328.821442,279.154205 333.827576,279.585541 
    z"
			/>
			<path
				fill="currentColor"
				opacity="1.000000"
				stroke="none"
				d="
    M848.824158,279.582581 
      C841.004089,279.983154 832.924377,280.037170 824.374268,280.016052 
      C829.020386,279.622864 834.133301,279.208496 839.254517,279.022797 
      C842.351196,278.910522 845.460754,279.152954 848.824158,279.582581 
    z"
			/>
		</svg>
	);

export default BundleLogo;
